export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
}

export enum AdultStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum ChildStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum FamilyStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum RelationshipToFamily {
  PRIMARY_CONTACT = 'primary_contact',
  PARENT = 'parent',
  GUARDIAN = 'guardian',
  OTHER = 'other',
}

export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'other',
  PREFER_NOT_TO_SAY = 'prefer_not_to_say',
}

export enum AgeGroup {
  INFANT = 'INFANT',
  TODDLER = 'TODDLER',
  PRESCHOOL = 'PRESCHOOL',
  CHILD = 'CHILD',
  TEEN = 'TEEN',
}

export enum RelationshipType {
  PARENT = 'parent',
  GRANDPARENT = 'grandparent',
  RELATIVE = 'relative',
  AUTHORIZED = 'authorized',
  EMERGENCY = 'emergency',
}

export enum AttendeeType {
  ADULT = 'adult',
  CHILD = 'child',
}

export enum EventStatus {
  DRAFT = 'draft',
  OPENED = 'opened',
  REG_OPENED = 'reg_opened',
  REG_CLOSED = 'reg_closed',
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
  DELETED = 'deleted',
}

export enum RegistrationStatus {
  REGISTERED = 'registered',
  CONFIRMED = 'confirmed',
  ATTENDED = 'attended',
  NO_SHOW = 'no_show',
  CANCELLED = 'cancelled',
}
